var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDenial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 15914"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 29,
    cy: 28,
    r: 25,
    fill: "#6C6C6C",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 52",
    d: "M16 34.5L44 34.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 18",
    d: "M20 23L20 23.95C20 26.1868 21.567 28 23.5 28C25.433 28 27 26.1868 27 23.95L27 23",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 19",
    d: "M31.5 23L31.5 23.95C31.5 26.1868 33.067 28 35 28C36.933 28 38.5 26.1868 38.5 23.95V23",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.375 26C43.875 26 44.5 28.455 44.5 29.6825C44.5 28.7619 44.5 26 47.625 26C50.125 26 50.75 28.455 50.75 29.6825C50.75 28.7619 50.75 26 53.875 26C56.375 26 57 28.455 57 29.6825V37.5079V40.7302V44.1386C57 47.8211 54.6562 54 45.2812 54C35.9062 54 32 48.0159 32 43.4127V41.6508C32 38.3135 32 35.2064 35.125 35.2064C37.625 35.2064 38.25 38.1217 38.25 38.8889V29.6825C38.25 28.7619 38.25 26 41.375 26Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 29.6825C44.5 28.455 43.875 26 41.375 26C38.25 26 38.25 28.7619 38.25 29.6825V40.7302M44.5 29.6825V37.9683M44.5 29.6825C44.5 28.7619 44.5 26 47.625 26C50.125 26 50.75 28.455 50.75 29.6825M47 45.1386C45.2813 42.7308 42.4167 41.6508 38.25 41.6508V38.8889C38.25 38.1217 37.625 35.2064 35.125 35.2064C32 35.2064 32 38.3135 32 41.6508V43.4127C32 48.0159 35.9062 54 45.2812 54C54.6562 54 57 47.8211 57 44.1386V37.5079M50.75 29.6825V37.9683M50.75 29.6825C50.75 28.7619 50.75 26 53.875 26C56.375 26 57 28.455 57 29.6825V40.7302",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenial);
export default __webpack_public_path__ + "static/media/Denial.61657658db471978dc30e42b843a7fc7.svg";
export { ForwardRef as ReactComponent };